import { auth } from "lib/firebase"
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { sendVerificationEmailIfAllowed } from './sendVerificationEmail';

// Creates the Firebase login, or signs in to it when an earlier sign-up created
// the login but didn't finish, so the person can continue instead of being stuck.
export const createOrSignInFirebaseUser = async (email, password) => {
  try {
    return await createUserWithEmailAndPassword(auth, email, password);
  } catch (error) {
    if (error.code !== 'auth/email-already-in-use') {
      throw toFirebaseError(error);
    }

    try {
      return await signInWithEmailAndPassword(auth, email, password);
    } catch {
      throw new Error("Account already exists.");
    }
  }
}

export const createFirebaseUser = async (data) => {
  const userCredential = await createOrSignInFirebaseUser(data.companyEmail, data.password);
  if (!userCredential.user.emailVerified) {
    await sendVerificationEmailIfAllowed();
  }

  return userCredential;
}

export const toFirebaseError = (error) => {
  if (error.code === 'auth/email-already-in-use') {
    return new Error("Account already exists.");
  } else if (error.code === 'auth/weak-password') {
    return new Error("Password is too weak.");
  } else if (error.code === 'auth/invalid-email') {
    return new Error("Invalid e-mail address");
  }

  return error;
}
